export default __webpack_public_path__ + "static/media/FORWARDLanding.2248470b.jpg";